import { Alert, Box } from '@mui/material';
import AnswersCheckbox from '@/components/exercise/answers-checkbox';
import AnswersCheckboxes from '@/components/exercise/answers-checkboxes';
import AnswersRadio from '@/components/exercise/answers-radio';
import AnswersSequence from '@/components/exercise/answers-sequence';
import type { Question } from '@/types';

export default function Answers({
  question,
  result,
  preview,
}: {
  question: Question;
  result?: boolean;
  preview?: boolean;
}) {
  const { answers, type } = question;

  if (!answers || answers.length === 0 || !question) {
    return <Alert severity="error">Inhalte konnten nicht gefunden werden.</Alert>;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {type === 'mc' && <AnswersCheckbox question={question} result={result} preview={preview} />}
      {type === 'mctf' && (
        <AnswersCheckboxes question={question} result={result} preview={preview} />
      )}
      {(type === 'tf' || type === 'sc') && (
        <AnswersRadio question={question} result={result} preview={preview} />
      )}
      {type === 'sq' && <AnswersSequence question={question} result={result} preview={preview} />}
    </Box>
  );
}
